import { Route } from '@angular/router';
import { DC_ROUTING } from 'src/app/shared/routing.tokens';

import { localTournamentRoutes } from '../local-tournaments/local-tournaments.routes';
import { onlineTournamentRoutes } from '../online-tournaments/online-tournaments.routes';

export const tournamentRoutes: Route[] = [
    {
        path: DC_ROUTING.TOURNAMENTS_OVERVIEW,
        loadComponent: () => import('./pages/tournaments/tournaments.component').then((c) => c.TournamentsComponent),
    },
    ...localTournamentRoutes,
    ...onlineTournamentRoutes,
];
